import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "regenerator-runtime/runtime.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useEffect, useState, useRef } from 'react';
import { Button, useUser } from 'components';
import { showApiError } from 'utils';
import { getInterestsFeesReportAmounts, sendRequestReport } from 'services';
import RequestAmountsModal from './RequestAmountsModal';
import { tableWrap, reportTable, reportTableRow } from './styles';
import { jsx as ___EmotionJSX } from "@emotion/react";

var AccumulatedReporting = function AccumulatedReporting() {
  var _userInfo$currentOffi;

  var _useUser = useUser(),
      userInfo = _useUser.userInfo,
      roleAdditionalData = _useUser.roleAdditionalData;

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      interestsFeesReportAmounts = _useState2[0],
      setInterestsFeesReportAmounts = _useState2[1];

  var amountModalRef = useRef();
  var isTenantManager = roleAdditionalData.isTenantManager,
      isFranchiseeOwner = roleAdditionalData.isFranchiseeOwner,
      isOfficeManager = roleAdditionalData.isOfficeManager;
  useEffect(function () {
    fetchInterestsFeesReportAmounts();
  }, [userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$currentOffi = userInfo.currentOffice) === null || _userInfo$currentOffi === void 0 ? void 0 : _userInfo$currentOffi.id]);

  var fetchInterestsFeesReportAmounts = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _userInfo$currentOffi2;

      var _yield$getInterestsFe, _yield$getInterestsFe2, res, err;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getInterestsFeesReportAmounts(_objectSpread(_objectSpread({}, (isFranchiseeOwner || isOfficeManager) && {
                franchisee: userInfo === null || userInfo === void 0 ? void 0 : userInfo.franchisee_id
              }), isOfficeManager && {
                office: userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$currentOffi2 = userInfo.currentOffice) === null || _userInfo$currentOffi2 === void 0 ? void 0 : _userInfo$currentOffi2.id
              }));

            case 2:
              _yield$getInterestsFe = _context.sent;
              _yield$getInterestsFe2 = _slicedToArray(_yield$getInterestsFe, 2);
              res = _yield$getInterestsFe2[0];
              err = _yield$getInterestsFe2[1];

              if (!err) {
                _context.next = 8;
                break;
              }

              return _context.abrupt("return", showApiError(err));

            case 8:
              setInterestsFeesReportAmounts(res);

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function fetchInterestsFeesReportAmounts() {
      return _ref.apply(this, arguments);
    };
  }();

  var handleSendRequestReport = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(data) {
      var _amountModalRef$curre;

      var _yield$sendRequestRep, _yield$sendRequestRep2, err;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return sendRequestReport({
                franchisee_id: data === null || data === void 0 ? void 0 : data.franchisee_id,
                office_id: data === null || data === void 0 ? void 0 : data.office_id,
                amount: data === null || data === void 0 ? void 0 : data.available_for_report_amount,
                status: data !== null && data !== void 0 && data.isRequest ? 'requested' : 'sent'
              });

            case 2:
              _yield$sendRequestRep = _context2.sent;
              _yield$sendRequestRep2 = _slicedToArray(_yield$sendRequestRep, 2);
              err = _yield$sendRequestRep2[1];

              if (!err) {
                _context2.next = 7;
                break;
              }

              return _context2.abrupt("return", showApiError(err));

            case 7:
              (_amountModalRef$curre = amountModalRef.current) === null || _amountModalRef$curre === void 0 ? void 0 : _amountModalRef$curre.close();
              fetchInterestsFeesReportAmounts();

            case 9:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleSendRequestReport(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var reportButton = function reportButton(isRequest, data) {
    return ___EmotionJSX(Button, {
      small: true,
      type: isRequest ? 'info' : 'warning',
      onClick: function onClick() {
        var _amountModalRef$curre2;

        return (_amountModalRef$curre2 = amountModalRef.current) === null || _amountModalRef$curre2 === void 0 ? void 0 : _amountModalRef$curre2.open(_objectSpread(_objectSpread({}, data), {}, {
          isRequest: isRequest
        }));
      }
    }, isRequest ? 'Изискай отчет' : 'Изпрати отчет');
  };

  var renderActionButton = function renderActionButton(data) {
    var isOffice = !!(data !== null && data !== void 0 && data.office_id);

    switch (true) {
      case (data === null || data === void 0 ? void 0 : data.available_for_report_amount) === '0.00':
        return null;

      case !isOffice && isTenantManager:
        return reportButton(true, data);

      case isOffice && isFranchiseeOwner:
        return reportButton(true, data);

      case !isOffice && isFranchiseeOwner:
        return reportButton(false, data);

      case isOffice && isOfficeManager:
        return reportButton(false, data);

      default:
        return null;
    }
  };

  return ___EmotionJSX(React.Fragment, null, ___EmotionJSX("div", {
    css: tableWrap
  }, ___EmotionJSX("table", {
    css: reportTable
  }, ___EmotionJSX("thead", null, ___EmotionJSX("tr", null, ___EmotionJSX("th", null, "\u041A\u0440\u0435\u0434\u0438\u0442\u0435\u043D \u043F\u043E\u0441\u0440\u0435\u0434\u043D\u0438\u043A"), ___EmotionJSX("th", null, "\u041D\u0430\u0442\u0440\u0443\u043F\u0430\u043D\u0430 \u0441\u0443\u043C\u0430 \u0437\u0430 \u043E\u0442\u0447\u0438\u0442\u0430\u043D\u0435"), ___EmotionJSX("th", null, "\u0414\u0435\u0439\u0441\u0442\u0432\u0438\u0435"))), ___EmotionJSX("tbody", null, interestsFeesReportAmounts === null || interestsFeesReportAmounts === void 0 ? void 0 : interestsFeesReportAmounts.map(function (el) {
    return ___EmotionJSX("tr", {
      css: reportTableRow(!!(el !== null && el !== void 0 && el.office_id)),
      key: el === null || el === void 0 ? void 0 : el.name
    }, ___EmotionJSX("td", null, el === null || el === void 0 ? void 0 : el.name), ___EmotionJSX("td", null, el === null || el === void 0 ? void 0 : el.available_for_report_amount, " ", el === null || el === void 0 ? void 0 : el.currency), ___EmotionJSX("td", null, renderActionButton(el)));
  })))), ___EmotionJSX(RequestAmountsModal, {
    ref: amountModalRef,
    onSubmit: handleSendRequestReport
  }));
};

export default AccumulatedReporting;